export const translations = {
  nome: {
    pt: "Nome",
    en: "Name",
    de: "Beschreibung",
    es: "Nombre",
  },
  limparFiltro: {
    pt: "Limpar Filtro",
    en: "Clear Filter",
    de: "Filter zurücksetzen",
    es: "Filtro limpio",
  },
  fechar: {
    pt: "Fechar",
    en: "Close",
    de: "Schließen",
    es: "Cerrar",
  },
  filtrar: {
    pt: "Filtrar",
    en: "Filter",
    de: "Filtern",
    es: "Filtrar",
  },
  descricao: {
    pt: "Descrição",
    en: "Description",
    de: "Beschreibung",
    es: "Descripción",
  },
};
